/*
 * TermsOfUse Messages
 *
 * This contains all the text for the TermsOfUse component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.TermsOfUse.title',
    defaultMessage: 'Terms of Use',
  },
  privacyPolicy: {
    id: 'app.containers.TermsOfUse.privacyPolicy',
    defaultMessage: 'Read Privacy Policy',
  },
});
